import React from 'react';
import * as PropTypes from 'prop-types';
import reportDetails from '../../Navigation/reportDetails';
import commonStrings from '../../../resources/commonStrings';
import DropdownDataMenu from '../../DropdownMenu/DropdownDataMenu';
import { getTermsForPartnerURI } from '../../../http-clients/partner-config';
import dropdownStyles from '../../DropdownMenu/DropdownMenu.module.css';
import styles from './RecoveryGoalSettingReport.module.css';
import RLPError from '../../ErrorPage/RLPError';

const propTypes = {
  partnerBid: PropTypes.string.isRequired,
  sessionToken: PropTypes.shape({ headers: PropTypes.shape({ Authorization: PropTypes.string.isRequired }) })
    .isRequired,
  setTermSelection: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

function TermSelection({ partnerBid, sessionToken, setTermSelection, disabled }) {
  /**
   * Pulls the term data out of API response from the partner-config response
   * @param apiData The response data from the api
   * @returns {[]} An array of terms
   */
  const termDataFn = (apiData) => {
    const results = [];
    try {
      if (apiData) {
        if (apiData.terms) {
          const fall2020Term = apiData.terms.find((termItem) => {
            return `${termItem.termNumber}` === '202004';
          });

          const spring2021Term = apiData.terms.find((termItem) => {
            return `${termItem.termNumber}` === '202102';
          });

          if (fall2020Term && spring2021Term) {
            // Limit to Fall 2019, Winter 2019, Spring 2020
            const allowedTermNumbers = ['201904', '202001', '202002'];
            apiData.terms.reduce((acc, termItem) => {
              if (allowedTermNumbers.includes(`${termItem.termNumber}`)) {
                if (
                  !acc.find((item) => {
                    return item.termNumber === termItem.termNumber;
                  })
                ) {
                  const selectionItem = {
                    displayText: termItem.name,
                    value: termItem.businessIdentifier,
                    termNumber: termItem.termNumber,
                    additional: {
                      currentTerm: fall2020Term.businessIdentifier,
                      springTerm: spring2021Term.businessIdentifier,
                    },
                  };
                  acc.push(selectionItem);
                }
              }

              return acc;
            }, results);
            results.sort((t1, t2) => (parseInt(t1.termNumber, 10) > parseInt(t2.termNumber, 10) ? 1 : -1));
          }
          // TODO - UX input needed
          // else{
          //     // No Spring && Fall 2020 - We should tell users we cannot generate report
          // }
        } else {
          throw new RLPError({}, 'Unexpected term data response.  Please contact your system administrator');
        }
      }
    } catch (err) {
      throw new RLPError(
        {},
        'An error occurred determining term options.  Please contact your system administrator',
        err
      );
    }

    return results;
  };

  return (
    <>
      <h3 className={`${styles['title']} heading-5`}>{commonStrings.recoveryGoalSettingReport.title}</h3>
      <div className={styles['top-container']}>
        <div className={styles['data-container']}>
          <p className={`${styles['title']} nwea-ds-v1-typography-body-default`}>
            {commonStrings.recoveryGoalSettingReport.description}
          </p>
          <p className={`${styles['title']} nwea-ds-v1-typography-body-default`}>
            {commonStrings.recoveryGoalSettingReport.instructions}
          </p>
          <div className={styles['options-container']}>
            <label className={`${dropdownStyles['label']}`}>Term:</label>
            <DropdownDataMenu
              ariaLabel={commonStrings.recoveryGoalSettingReport.termSelectionLabel}
              containingTab={reportDetails.recoveryGoalSetting.urlEndPoint}
              dataFn={termDataFn}
              identifier={'recoveryGoalSettingTermSelection'}
              sessionToken={sessionToken}
              setStateFn={setTermSelection}
              URLConfig={{ method: 'get', url: getTermsForPartnerURI(partnerBid) }}
              disabled={disabled}
            />
          </div>
          <div className={styles['school-selection-text']}>
            <div className={'nwea-ds-v1-typography-body-default'}>
              {commonStrings.recoveryGoalSettingReport.selectSchoolsTitle}
            </div>
            <div className={'nwea-ds-v1-typography-body-default'}>
              {commonStrings.recoveryGoalSettingReport.selectSchoolsDescription}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

TermSelection.propTypes = propTypes;

export default TermSelection;
